export const NAME = 'login';